export default {"src":"/_next/static/media/effective-security-controls.2c368233.svg","height":512,"width":576,"blurWidth":0,"blurHeight":0};